import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'

const BASE_CLASS = 'mt-UserAvatar'
const IMAGE_CLASS = `${BASE_CLASS}-image`
const LABEL_CLASS = `${BASE_CLASS}-label`

const UserAvatar = ({imageSrc, label}) => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const USER_DEFAULT_AVATAR_URL = config.get('USER_DEFAULT_AVATAR_URL')

  return (
    <div className={BASE_CLASS}>
      <div className={IMAGE_CLASS}>
        <AtomImage src={imageSrc || USER_DEFAULT_AVATAR_URL} alt={label} />
      </div>
      {label ? <p className={LABEL_CLASS}>{label}</p> : null}
    </div>
  )
}

UserAvatar.displayName = 'UserAvatar'
UserAvatar.propTypes = {
  imageSrc: PropTypes.string,
  label: PropTypes.string
}

export default UserAvatar
